import { useMemo } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesPreview";
import AboutAttorneySection from "./components/AboutAttorneySection";
import CTASection from "./components/CTASection";
import SEOHead from "../../components/feature/SEOHead";

export default function Home() {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) || "https://willstrusts-junlawfirm.com";

  const jsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Law Office of Hong-min Jun",
    "alternateName": "Jun Law Office",
    "description": "Multilingual estate planning attorney in Fishers, Indiana specializing in wills, trusts, and prenuptial agreements for immigrant families.",
    "url": siteUrl,
    "telephone": "+13177012768",
    "email": "info@junlawoffice.com",
    "priceRange": "$$",
    "currenciesAccepted": "USD",
    "availableLanguage": ["English", "Korean", "Chinese"],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "10150 Lantern Rd, Suite #175",
      "addressLocality": "Fishers",
      "addressRegion": "IN",
      "postalCode": "46037",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 39.9567,
      "longitude": -85.9900
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "14:00"
      }
    ],
    "areaServed": {
      "@type": "State",
      "name": "Indiana"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Estate Planning Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Will Drafting" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Trust Formation" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Prenuptial Agreement" } }
      ]
    },
    "founder": {
      "@type": "Person",
      "name": "Hong-min Jun",
      "jobTitle": "Attorney at Law"
    }
  }), [siteUrl]);

  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead
        title="Jun Law Office | Estate Planning Attorney Fishers IN | Wills, Trusts & Prenuptial"
        description="Multilingual estate planning attorney in Fishers, Indiana. Expert wills, trusts & prenuptial agreements for immigrant families. Serving in English, Korean & Chinese. Call (317) 701-2768."
        keywords="estate planning attorney Fishers Indiana, wills trusts immigrant families, Korean attorney Indianapolis, prenuptial agreement Indiana, multilingual estate planning"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ServicesSection />
        <AboutAttorneySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
